import type { MutationErrors } from '../../../../common/api/graphql/mutationErrorType';
import { mutationFailure } from '../actions';
import type { AppThunkAction } from '../thunkType';

export const handleMutationErrors =
  (errors: MutationErrors): AppThunkAction<Promise<void>> =>
  dispatch => {
    const commonErrors = errors.map(error => error.message);
    dispatch(mutationFailure(commonErrors));
    return Promise.reject(JSON.stringify(errors));
  };
